import React, { useState } from 'react'
import cookies from 'react-cookies'
import { Modal } from 'antd'
import { useSelector } from 'react-redux'

const SwitchOrganizationModal = ({ modalOpen, close, switchOrganization }) => {
  let selectedNamedUserEmployerId = cookies.load('selectedNamedUserEmployerId')

  const namedUserEmployerProfiles = useSelector(
    state => state.user.namedUserEmployerProfiles
  )

  const [selected, setSelected] = useState(selectedNamedUserEmployerId)

  const onSwitchOrganization = () => {
    switchOrganization(selected)
  }

  return (
    <Modal
      width={400}
      footer={null}
      visible={modalOpen}
      onCancel={close}
      className="p-0 candidateAlertModal shadow-lg"
    >
      <div className="modal-head bg-voyage py-5 px-6 lg:px-9 rounded-tl rounded-tr flex items-center justify-between">
        <p className="font-sans font-bold text-[20px] leading-tight text-white mb-0">
          Switch Organization
        </p>
        <img
          onClick={close}
          className="w-4 cursor-pointer mb-0"
          src="/icons/icon-modal-close.svg"
          alt="Close modal icon"
        />
      </div>
      <div className="bg-white h-80 flex flex-col">
        <div className="flex-1 p-4 overflow-y-auto">
          {namedUserEmployerProfiles?.map(profile => (
            <div
              key={profile.id}
              className="flex justify-between items-center cursor-pointer bg-white hover:bg-gray-300 p-2 my-2"
              onClick={() => setSelected(profile.id.toString())}
            >
              <span className="font-sans font-semibold text-base">
                {profile.name}
              </span>
              {profile.id.toString() === selected && (
                <div className="flex items-center justify-center bg-voyage h-6 w-6 rounded-full">
                  <img src="/icons/check-mark.svg" className="mb-0" />
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="flex justify-end p-4">
          <button
            className="bg-voyage py-2 px-4 font-sans text-white text-last font-bold rounded"
            onClick={onSwitchOrganization}
          >
            Switch
          </button>
        </div>
      </div>
    </Modal>
  )
}
export default SwitchOrganizationModal
